<template>
    <div class="queue-view">
      {{$gettext('Estás en cola')}}
    </div>
</template>

<script>
export default {
    name: 'QueueView',
}
</script>